import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import TopLable from '@/components/common/TopLable';
import Leave from '@/components/Icons/Leave';
import PendingAR from '@/components/Icons/PendingAR';
import PendingIcon from '@/components/Icons/PendingIcon';
import PendingLeave from '@/components/Icons/PendingLeaves';
import PendingWFH from '@/components/Icons/PendingWFH';
import PresentIcon from '@/components/Icons/PresentIcon';
import ViewIcon from '@/components/Icons/ViewIcon';
import CardLayout from '@/components/Layout/CardLayout';
import Layout from '@/components/Layout/Layout';
import useFilter from '@/hooks/useFilter';
import {
  IAttendanceCountResponse,
  IAttendanceFilterState,
  IAttendancePagination,
  IAttendanceResponse,
  IAttendanceState,
  IAttendanceStatus,
  ITableData,
  ITopViewItems,
} from '@/interfaces/attendance.model';
import { IFilterSideBarForm } from '@/interfaces/common.model';
import { setUpdateFilterStates } from '@/redux/features/UserSlice';

import { RootState } from '@/redux/store';
import { calculateHours } from '@/utility/CommonFunctions';
import {
  attendanceStatus,
  capitalizeFirstLetter,
  getFilterUrl,
  orderByList,
  showToastNotification,
} from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
interface IAttendancePageState {
  tableLoader: boolean;
  filterData: string;
  sortByDate: string | string[];
}
const MyAttendance = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const filterDetails = useSelector(
    (state: RootState) => state.user.filtersStates,
  );
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const dispatch = useDispatch();
  const [state, setState] = useState<IAttendanceState>({
    attendanceCount: null,
    attendanceList: [],
  });
  const [filterData, setFilterData] = useState<IAttendanceFilterState>({
    sortByDate: location?.state?.month || [
      moment().startOf('month').format('YYYY-MM-DD'),
      moment().endOf('month').format('YYYY-MM-DD'),
    ],
  });
  const [pagination, setPagination] = useState<IAttendancePagination>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    searchQuery: '',
  });
  const [pageStates, setPageStates] = useState<IAttendancePageState>({
    tableLoader: false,
    filterData: '',
    sortByDate: location?.state?.month || [
      moment().startOf('month').format('YYYY-MM-DD'),
      moment().endOf('month').format('YYYY-MM-DD'),
    ],
  });

  const tableHeading: ITableColumn<ITableData>[] = [
    { value: 'index', label: '#' },
    { value: 'attendanceDate', label: 'Date' },
    { value: 'shift', label: 'Shift' },
    { value: 'checkInTime', label: 'Check In' },
    { value: 'checkOutTime', label: 'Check Out' },
    { value: 'workingHours', label: 'Working Hours' },
    { value: 'attendanceStatus', label: 'Status' },
  ];

  useEffect(() => {
    getAttendance();
  }, [
    filterData?.sortByDate,
    id,
    pageStates?.sortByDate,
    pagination?.currentPage,
    filterDetails?.attendanceStatus,
    filterDetails.pageSize,
    filterDetails?.orderBy,
    pagination?.searchQuery,
  ]);
  useEffect(() => {
    if (!id) {
      getAttendanceCount();
    }
  }, [filterData?.sortByDate]);

  const getAttendance = async () => {
    try {
      const filterState = {
        pageNumber: pagination?.currentPage,
        pageSize: filterDetails?.pageSize,
        startDate: pageStates?.sortByDate[0],
        endDate: pageStates?.sortByDate[1],
        userId: id ? id : '',
        orderBy: filterDetails?.orderBy,
        search: pagination.searchQuery,
        status: filterDetails?.attendanceStatus,
      };
      const API = `${API_URL}${API_ENDPOINT?.getAttendance}?${getFilterUrl(filterState)}${!id ? '&myAttendance=true' : ''}`;
      setPageStates((prev) => ({
        ...prev,
        tableLoader: !prev.tableLoader,
      }));
      const response: IAttendanceResponse = await callApi(API, {
        method: 'GET',
      });
      console.log(response);
      if (response?.status === true) {
        console.log(response?.data?.attendance?.[0]?.attendances);
        const newData = response?.data?.attendance?.[0]?.attendances?.map(
          (item, index) => ({
            ...item,
            index: index + 1,
            attendanceDate: moment.utc(item?.checkInTime).format('DD/MM/YYYY'),
            shift: response?.data?.attendance?.[0]?.Shift?.shiftName,
            checkInTime: item?.checkInTime
              ? item?.status === 7
                ? '00:00'
                : moment.utc(item?.checkInTime).format('HH:mm')
              : '--',
            checkOutTime: item?.checkOutTime
              ? item?.status === 7
                ? '00:00'
                : moment.utc(item?.checkOutTime).format('HH:mm')
              : moment.utc(item?.checkInTime).isBefore(moment(), 'day') &&
                  item?.checkInTime
                ? '00:00'
                : '--',
            workingHours:
              item?.checkOutTime ||
              !moment.utc(item?.checkInTime).isBefore(moment(), 'day')
                ? item?.status === 7
                  ? '00:00'
                  : calculateHours(item?.checkInTime, item?.checkOutTime) ||
                    '--'
                : '00:00',
            attendanceStatus: item ? item?.status : 2,
          }),
        );
        setState((pre) => ({
          ...pre,
          attendanceList:
            response?.data?.attendance[0]?.attendances?.length > 0
              ? newData
              : [],
        }));
        // setPagination((prev) => ({
        //   ...prev,
        //   total: response?.data?.pageInfo?.total ?? 0,
        //   totalPages: response?.data?.pageInfo?.totalPages ?? 0,
        // }));
        setPageStates((pre) => ({
          ...pre,
          tableLoader: !pre?.tableLoader,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
    }
  };

  const getAttendanceCount = async () => {
    try {
      const filter = {
        startDate: filterData?.sortByDate[0],
        endDate: filterData?.sortByDate[1],
      };
      const API =
        API_URL +
        API_ENDPOINT.getLeaveCount +
        '?type=attendance&' +
        getFilterUrl(filter);
      const response: IAttendanceCountResponse = await callApi(API, {
        method: 'GET',
      });
      if (response?.status === true) {
        setState((pre) => ({ ...pre, attendanceCount: response.data }));
      } else {
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
    }
  };
  const topViewItems: ITopViewItems[] = [
    {
      label: 'Present',
      value: state?.attendanceCount?.present,
      icon: <PresentIcon />,
    },
    {
      label: 'Absent',
      value: state?.attendanceCount?.absent,
      icon: <PresentIcon />,
    },
    {
      label: 'Leaves',
      value: state?.attendanceCount?.leaves,
      icon: <Leave />,
    },
    {
      label: 'Pending',
      value: state?.attendanceCount?.pending,
      icon: <PendingIcon />,
    },
    {
      label: 'Pending Leave',
      value: state?.attendanceCount?.pendingLeave,
      icon: <PendingLeave />,
    },
    {
      label: 'Pending AR',
      value: state?.attendanceCount?.pendingAR,
      icon: <PendingAR />,
    },
    {
      label: 'Pending WFH',
      value: state?.attendanceCount?.pendingOD,
      icon: <PendingWFH />,
    },
  ];
  const singleDateChangeHandler = (date: Date | null) => {
    if (!date || !moment(date).isValid()) return;

    const selectedStartDate = moment(date)
      .startOf('month')
      .format('YYYY-MM-DD');
    const selectedEndDate = moment(date).endOf('month').format('YYYY-MM-DD');

    setPageStates((prevState) => ({
      ...prevState,
      sortByDate: [selectedStartDate, selectedEndDate],
    }));
    setFilterData((prevState) => ({
      ...prevState,
      sortByDate: [selectedStartDate, selectedEndDate],
    }));
  };

  const handleData = (data: Partial<IFilterSideBarForm> | null) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: 1,
    }));
    dispatch(
      setUpdateFilterStates({ attendanceStatus: data?.attendanceStatus }),
    );
  };

  const actionData = [
    {
      label: 'View',
      className: 'btn btn-link',
      icon: <ViewIcon />,
      title: 'view',
      clickHandler: (data: ITableData) =>
        navigate(`${RoutesLink?.attendanceLogs}`, { state: data }),
    },
  ];

  const { handleChangePageSize, orderByHandler } = useFilter(
    pagination,
    setPagination,
  );

  return (
    <Layout>
      <div className="content">
        <MainHeading
          title={`${id ? capitalizeFirstLetter(location?.state?.data?.name) : ''} Attendance`}
          singleDateChangeHandler={id ? null : singleDateChangeHandler}
          pageState={{
            sortBySingleDate: pageStates?.sortByDate,
          }}
          pickerType="month"
          showbBackButton={id ? true : false}
        />
        {!id && <TopLable items={topViewItems} isMoreData={true} />}
        <CardLayout cardStyle=" mb-4" isGrid={tableView === 'grid'}>
          <FilterComponent<IAttendanceStatus>
            filterArray={{
              isShow: true,
            }}
            isGrid={false}
            // handleSearch={handleSearchChange}
            attendanceList={attendanceStatus}
            orderByHandler={orderByHandler}
            orderByList={orderByList}
            sortHandler={handleData}
          />
          <CommonTable<ITableData>
            tableHeading={tableHeading}
            tableData={state?.attendanceList}
            ActionData={id ? [] : actionData}
            pageSize={filterDetails?.pageSize}
            count={pagination?.total ?? 0}
            isLoading={pageStates?.tableLoader}
            currentPage={pagination?.currentPage}
            totalPages={pagination?.totalPages}
            handleChangePageSize={handleChangePageSize}
          />
        </CardLayout>
      </div>
    </Layout>
  );
};

export default MyAttendance;
